// Parwin Wetline pop-up (Davide, 17 Oct 2026). Data and styles: snippets/parwin-wetline-popup.liquid.
// Opens when the theme reports a product-form add (product card or product page) of a heat tool costing at least
// minPence. Lists every in-stock Wetline product, ordered for the tool type, with the offer price and a one-tap Add.
(function () {
  if (window.__ppWlpBound) return;
  window.__ppWlpBound = true;
  var dataEl = document.getElementById('pp-wlp-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D.products || !D.products.length) return;

  // Colour, smoothing and heat protection first for every tool (Davide), then the rest by tool type.
  var ORDER = {
    'Straighteners': ['colour', 'smoothing', 'heat', 'detangle', 'brush', 'volume', 'other'],
    'Curlers': ['colour', 'smoothing', 'heat', 'volume', 'detangle', 'brush', 'other'],
    'Hair Dryers': ['colour', 'smoothing', 'heat', 'volume', 'brush', 'detangle', 'other'],
    'Hot Air Stylers': ['colour', 'smoothing', 'heat', 'volume', 'brush', 'detangle', 'other'],
  };
  // Davide 27 Oct 2026: every heat tool gets one offer, the heat protection spray at its own discount (D.heatPct, no
  // minimum). If the spray is out of stock the pop-up does not open.
  var HEAT_ONLY = ['Straighteners', 'Curlers', 'Hair Dryers', 'Hot Air Stylers'];
  var PCT = D.heatPct || D.pct;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var fmt = function (pence) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: D.currency || 'GBP' }).format(pence / 100); }
    catch (e) { return '£' + (pence / 100).toFixed(2); }
  };
  var offer = function (pence) { return pence - Math.floor(pence * PCT / 100); }; // same rounding as the cart strip
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var el = null, lastFocus = null;
  function close() {
    if (!el) return;
    if (el.open && el.close) { try { el.close(); } catch (e) {} }
    el.hidden = true;
    document.documentElement.classList.remove('pp-wlp-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function build(toolTitle, toolType) {
    var order = ORDER[toolType] || ORDER['Straighteners'];
    var list = D.products.slice().sort(function (a, b) {
      var ia = order.indexOf(a.cat), ib = order.indexOf(b.cat);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    if (HEAT_ONLY.indexOf(toolType) > -1) {
      var heat = list.filter(function (p) { return p.cat === 'heat'; });
      if (!heat.length) return false;
      list = heat;
    }
    var single = list.length === 1;
    var items = list.map(function (p) {
      var v0 = p.variants[0];
      var picker = p.variants.length > 1
        ? '<select class="pp-wlp__select" data-pp-wlp-select aria-label="Choose option for ' + esc(p.title) + '">' +
          p.variants.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
        : '';
      return '<li class="pp-wlp__item" data-pp-wlp-product="' + p.id + '">' +
        '<a class="pp-wlp__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.alt || p.title) + '" width="220" height="220" loading="lazy">' : '') +
          '<span class="pp-wlp__badge">-' + PCT + '%</span></a>' +
        '<a class="pp-wlp__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="pp-wlp__price" data-pp-wlp-price><s>' + fmt(v0.price) + '</s><span>' + fmt(offer(v0.price)) + '</span></span>' +
        picker +
        '<button type="button" class="pp-wlp__add" data-pp-wlp-add="' + v0.id + '" aria-label="Add ' + esc(p.title) + ' to cart">+ Add</button>' +
      '</li>';
    }).join('');
    var html =
      '<div class="pp-wlp__card' + (single ? ' pp-wlp--single' : '') + '" role="dialog" aria-modal="true" aria-labelledby="pp-wlp-title">' +
        '<p class="pp-wlp__note">🎃 <strong>' + PCT + '% off every Wetline product</strong> with your Parwin tool. No minimum order, taken off automatically at checkout.</p>' +
        '<button type="button" class="pp-wlp__close" data-pp-wlp-close aria-label="Close">&times;</button>' +
        '<div class="pp-wlp__body">' +
          (single
            ? '<p class="pp-wlp__title" id="pp-wlp-title">Add a heat protectant</p>' +
              '<p class="pp-wlp__sub">Spray it on before you style with your ' + esc(toolTitle) + '. Add it now and save ' + PCT + '%.</p>'
            : '<p class="pp-wlp__title" id="pp-wlp-title">Complete the routine for your ' + esc(toolTitle) + '</p>' +
              '<p class="pp-wlp__sub">Add any of these with your tool and save ' + PCT + '% on each one.</p>') +
          '<div class="pp-wlp__rail">' +
            '<button type="button" class="pp-wlp__arrow pp-wlp__arrow--prev" data-pp-wlp-arrow="-1" aria-label="Previous products" disabled>&#8249;</button>' +
            '<ul class="pp-wlp__list" role="list">' + items + '</ul>' +
            '<button type="button" class="pp-wlp__arrow pp-wlp__arrow--next" data-pp-wlp-arrow="1" aria-label="More products">&#8250;</button>' +
          '</div>' +
        '</div>' +
        '<div class="pp-wlp__foot">' +
          '<button type="button" class="pp-wlp__skip" data-pp-wlp-close>No thanks</button>' +
          (single ? '<button type="button" class="pp-wlp__done" data-pp-wlp-addclose>Add to cart &amp; save ' + PCT + '%</button>' : '<button type="button" class="pp-wlp__done" data-pp-wlp-close>Done</button>') +
        '</div>' +
      '</div>';
    if (!el) {
      // A modal <dialog>: the cart drawer is itself a modal dialog in the browser's top layer, so only another
      // modal dialog opened after it can sit above it (and stay clickable).
      el = document.createElement('dialog');
      el.className = 'pp-wlp';
      el.hidden = true;
      document.body.appendChild(el);
      el.addEventListener('click', onClick);
      el.addEventListener('change', onChange);
      el.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    }
    el.innerHTML = html;
    el.querySelector('.pp-wlp__list').addEventListener('scroll', arrows, { passive: true });
  }
  function arrows() {
    if (!el) return;
    var list = el.querySelector('.pp-wlp__list');
    var prev = el.querySelector('[data-pp-wlp-arrow="-1"]'), next = el.querySelector('[data-pp-wlp-arrow="1"]');
    if (!list || !prev || !next) return;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  }
  function onChange(e) {
    var sel = e.target.closest('[data-pp-wlp-select]');
    if (!sel) return;
    var item = sel.closest('.pp-wlp__item');
    var opt = sel.options[sel.selectedIndex];
    var price = Number(opt.dataset.price);
    item.querySelector('[data-pp-wlp-price]').innerHTML = '<s>' + fmt(price) + '</s><span>' + fmt(offer(price)) + '</span>';
    var btn = item.querySelector('[data-pp-wlp-add]');
    btn.dataset.ppWlpAdd = sel.value;
    btn.classList.remove('is-added');
    btn.textContent = '+ Add';
  }
  async function onClick(e) {
    if (e.target === el || e.target.closest('[data-pp-wlp-close]')) { e.preventDefault(); close(); return; }
    // Footer "Add to cart & save": adds the one product shown (unless already added), then closes.
    var ac = e.target.closest('[data-pp-wlp-addclose]');
    if (ac) {
      e.preventDefault();
      var addBtn = el.querySelector('[data-pp-wlp-add]');
      if (addBtn && !addBtn.classList.contains('is-added')) { ac.setAttribute('aria-busy', 'true'); await onClick({ target: addBtn, preventDefault: function () {} }); }
      close(); return;
    }
    var arrow = e.target.closest('[data-pp-wlp-arrow]');
    if (arrow) {
      var list = el.querySelector('.pp-wlp__list');
      var card = list.querySelector('.pp-wlp__item');
      list.scrollBy({ left: Number(arrow.dataset.ppWlpArrow) * ((card ? card.offsetWidth : 200) + 12) * 2, behavior: 'smooth' });
      setTimeout(arrows, 400);
      return;
    }
    var btn = e.target.closest('[data-pp-wlp-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try {
      var comp = document.querySelector('cart-items-component[data-section-id]');
      var body = { items: [{ id: Number(btn.dataset.ppWlpAdd), quantity: 1 }] };
      if (comp) body.sections = comp.dataset.sectionId;
      var res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      var result = await res.json();
      if (!res.ok) throw new Error(result.description || 'Could not add to cart');
      btn.classList.add('is-added');
      btn.textContent = '✓ Added';
      var cart = await (await fetch(root + 'cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'pp-wlp', data: { source: 'pp-wlp', itemCount: cart.item_count, variantId: btn.dataset.ppWlpAdd, sections: result.sections } } }));
    } catch (err) {
      btn.textContent = 'Try again';
      console.error('[Wetline pop-up]', err);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }
  function open(toolTitle, toolType) {
    if (build(toolTitle, toolType) === false) { document.documentElement.classList.remove('pp-wlp-pending'); return; }
    lastFocus = document.activeElement;
    el.hidden = false;
    if (el.showModal && !el.open) { try { el.showModal(); } catch (e) { el.setAttribute('open', ''); } }
    document.documentElement.classList.add('pp-wlp-open');
    requestAnimationFrame(arrows);
    var c = el.querySelector('.pp-wlp__close');
    if (c) c.focus({ preventScroll: true });
  }

  // Theme add-to-cart (product cards and product pages both use product-form-component).
  // No flash (Davide 17 Oct): decide in the same tick as the add event, keep the cart drawer invisible while it
  // opens, then open the pop-up on top as soon as the drawer is in place; the drawer shows behind the pop-up's dim
  // backdrop from then on, and is fully visible once the pop-up closes.
  function qualifies(cart, productId) {
    var lines = (cart.items || []).filter(function (i) { return String(i.product_id) === String(productId); });
    if (!lines.length) return null;
    var line = lines.reduce(function (a, b) { return b.price > a.price ? b : a; });
    return (D.heatTypes.indexOf(line.product_type) > -1 && line.price >= D.minPence) ? line : null;
  }
  function showOverDrawer(line) {
    var html = document.documentElement;
    html.classList.add('pp-wlp-pending');
    var t0 = Date.now();
    (function wait() {
      var drawer = document.querySelector('.cart-drawer__dialog');
      var ready = drawer && drawer.open;
      if (ready || Date.now() - t0 > 1500) {
        // one frame for the drawer to finish placing itself, still invisible
        requestAnimationFrame(function () {
          open(line.product_title, line.product_type);
          requestAnimationFrame(function () { html.classList.remove('pp-wlp-pending'); });
        });
        return;
      }
      setTimeout(wait, 16);
    })();
  }
  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    if (d.didError || d.source !== 'product-form-component' || !d.productId) return;
    if (el && el.open) return;
    var res = e.detail && e.detail.resource;
    if (res && res.items) {
      var line = qualifies(res, d.productId);
      if (line) showOverDrawer(line);
      return;
    }
    // no cart in the event: hide the drawer straight away while we look it up
    document.documentElement.classList.add('pp-wlp-pending');
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = qualifies(cart, d.productId);
      if (line) showOverDrawer(line);
      else document.documentElement.classList.remove('pp-wlp-pending');
    }).catch(function (err) { document.documentElement.classList.remove('pp-wlp-pending'); console.error('[Wetline pop-up]', err); });
  });
  window.ppWetlinePopup = { open: open, close: close }; // for testing
})();
